// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"28c09721","626":"507a7849","651":"67262280"}[chunkId] + ".chunk.js";
};